module.exports = "/static/media/NoEsimsAssignedIllustration.f9aa40e6.png";